import { render } from "./MyPost.vue?vue&type=template&id=769feb2a"
import script from "./MyPost.vue?vue&type=script&lang=js"
export * from "./MyPost.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__